import React from "react";
import CotizacionUbicacionPaso1 from "../../components/CotizacionHogar/CotizacionUbicacionPaso1";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {contenidosFetch, tokenIframe} from "../../redux/actions/aContenidos";
import {ProductosMenuFetch} from "../../redux/actions/aMenus";

class ContainerRenovaciones extends React.Component {
  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    await this.props.ProductosMenuFetch();
    await tokenIframe()
  }

  render() {
    let usuario = this.props.datosUsuario.cliCodigoCore
    usuario = window.btoa(usuario)
    let url = this.props.productosMenu.setDataUrlRenovaciones ? this.props.productosMenu.setDataUrlRenovaciones + usuario + "&tk=" +localStorage.getItem('tokenIframe')
    : ''
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <iframe className={"iframe-renovaaciones"} src={url}/>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  productosMenu: state.datosProductosMenu,
  datosUsuario: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = (dispatch) => {
  return {
    ProductosMenuFetch: () => dispatch(ProductosMenuFetch()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerRenovaciones)
);
